import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { DEFAULT_MENU_THEME } from "../config/menuThemes";

const readSelectedItem = (itemId) => {
  try {
    const item = JSON.parse(localStorage.getItem("selectedItem"));
    return item?._id === itemId ? item : null;
  } catch {
    return null;
  }
};

const readCart = (menuLink) => {
  try {
    const value = JSON.parse(localStorage.getItem(`cart_${menuLink}`));
    return Array.isArray(value) ? value : [];
  } catch {
    return [];
  }
};

const useCustomerFoodDetail = () => {
  const { itemId, menuLink: routeMenuLink } = useParams();
  const menuLink = routeMenuLink || localStorage.getItem("selectedMenuLink");
  const navigate = useNavigate();
  const location = useLocation();
  const [item] = useState(() => readSelectedItem(itemId));
  const [quantity, setQuantity] = useState(0);
  const theme = (menuLink && localStorage.getItem(`theme_${menuLink}`)) || DEFAULT_MENU_THEME;

  useEffect(() => {
    const cartItem = readCart(menuLink).find((entry) => entry._id === itemId);
    setQuantity(cartItem?.quantity || 0);
  }, [itemId, menuLink]);

  const changeQuantity = (delta) => {
    if (!item || !menuLink) return;
    const cart = readCart(menuLink).map((entry) => ({ ...entry }));
    const existing = cart.find((entry) => entry._id === item._id);
    if (existing) existing.quantity += delta;
    else if (delta > 0) cart.push({ ...item, quantity: 1 });
    const updated = cart.filter((entry) => entry.quantity > 0);
    localStorage.setItem(`cart_${menuLink}`, JSON.stringify(updated));
    setQuantity(updated.find((entry) => entry._id === item._id)?.quantity || 0);
  };

  return {
    item,
    menuLink,
    quantity,
    theme,
    changeQuantity,
    goToMenu: () => navigate(`/menu/${menuLink}${location.search}`),
    goToCart: () => navigate(`/restaurant/cart/${menuLink}${location.search}`),
    goBack: () => navigate(-1),
  };
};

export default useCustomerFoodDetail;
